const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/workouts/templates/$templateId.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/workouts/templates/$templateId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { getActiveWorkoutQuery } from '@/features/workouts/lib/get-active-workout.query';
import { getWorkoutTemplateQuery } from '@/features/workouts/lib/get-workout-template.query';
import { WorkoutsSkeleton } from '@/features/workouts/ui/workouts-skeleton';
export const Route = createFileRoute('/_authenticated/tracking/workouts/templates/$templateId')({
  beforeLoad: ({
    context,
    params
  }) => {
    const validated = context.deps.validators.workoutTemplateIdValidator.validate(params.templateId);
    if (!validated.ok) {
      throw redirect({
        to: '/tracking/workouts'
      });
    }
    return {
      templateId: validated.data
    };
  },
  loader: async ({
    context,
    location
  }) => {
    const deps = {
      controllers: {
        workoutController: context.deps.controllers.workoutController
      }
    };
    try {
      await Promise.all([context.queryClient.ensureQueryData(getWorkoutTemplateQuery(deps, context.templateId)), context.queryClient.ensureQueryData(getActiveWorkoutQuery(deps))]);
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  pendingComponent: WorkoutsSkeleton
});